import type { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';

export const noteCategoryRule = (): Rule => {
  const { t } = useTranslation();

  return ({
    message: t('Please enter correct note category'),
    required: true,
  });
};
